module.exports = __webpack_public_path__ + "static/media/orangeicon.333f51d2.jpg";